import { Service } from "../Service";
import { IApplication } from "./Application";

export class ApplicationService extends Service<IApplication>
{
}